/**
 * =============================================================================
 * Project: vue-boilerplate
 * Created Date: 2017-10-26, 11:38:36
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2017-11-07, 13:56:53
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2017 Telestrada
 * =============================================================================
 */

// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'LoadingOverlay',
  props: ['loginLoading'],
};



// WEBPACK FOOTER //
// ./src/components/Common/LoadingOverlay/component.js